<template>
  <a
    type="text"
    @click="handleChange"
    :class="['header-trigger-a', collapsed ? 'collapsed' : '']"
  >
    <Icon :type="icon" :size="size"></Icon>
  </a>
</template>

<script>
export default {
  name: 'HeaderTrigger',
  props: {
    collapsed: Boolean,
    icon: {
      type: String,
      default: 'navicon-round',
    },
    size: {
      type: Number,
      default: 26,
    },
  },
  methods: {
    // icon change
    handleChange() {
      this.$emit('on-change', !this.collapsed);
    },
  },
};
</script>

<style lang="less" scoped>
@size: 40px;
.trans {
  transition: transform 0.2s ease;
}

.header-trigger-a {
  margin-top: 12px;
  margin-left: 12px;
  width: @size;
  height: @size;
  padding: 7px;
  display: inline-block;
  text-align: center;
  color: #fff;
  &:hover {
    color: #57a3f3;
  }
  i {
    .trans;
    vertical-align: top;
  }
  &.collapsed i {
    transform: rotateZ(90deg);
    .trans;
  }
}
</style>
